import { can } from '@esentai/core/policy-dsl';

import { VIEW_COMMISSAR_ANSWER } from '@/features/currentUser/permissions/consts/permissions';
import { authorizeIf } from '@/features/currentUser/rbac';

export const canViewAnswer = authorizeIf(can(VIEW_COMMISSAR_ANSWER));
